var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	45850: () => (loadStrictSingletonVersion("default", "react", true, [1,18,3,1], () => (() => (__webpack_require__(96540))))),
	2282: () => (loadStrictSingletonVersion("default", "react-dom", true, [1,18,3,1], () => (() => (__webpack_require__(40961))))),
	45805: () => (loadStrictVersion("default", "@emotion/react", false, [1,11,13,5], () => (Promise.all([__webpack_require__.e(304), __webpack_require__.e(6539)]).then(() => (() => (__webpack_require__(54158))))))),
	19234: () => (loadStrictVersion("default", "graphql-ws", false, [1,5,16,0], () => (__webpack_require__.e(1549).then(() => (() => (__webpack_require__(23930))))))),
	82564: () => (loadStrictVersion("default", "axios", false, [1,1,8,4], () => (__webpack_require__.e(6828).then(() => (() => (__webpack_require__(84447))))))),
	22026: () => (loadStrictVersion("default", "uuid", false, [1,11,0,3], () => (__webpack_require__.e(5602).then(() => (() => (__webpack_require__(13221))))))),
	27321: () => (loadStrictVersion("default", "utf8", false, [1,3,0,0], () => (__webpack_require__.e(2412).then(() => (() => (__webpack_require__(90031))))))),
	36114: () => (loadStrictVersion("default", "@emotion/styled", false, [1,11,13,0], () => (__webpack_require__.e(9098).then(() => (() => (__webpack_require__(71479))))))),
	12843: () => (loadStrictVersion("default", "clsx", false, [1,2,1,1], () => (__webpack_require__.e(1783).then(() => (() => (__webpack_require__(34164))))))),
	18706: () => (loadStrictVersion("default", "react-router-dom", false, [1,7,9,3], () => (__webpack_require__.e(6744).then(() => (() => (__webpack_require__(64363))))))),
	5335: () => (loadStrictVersion("default", "zustand", false, [1,5,0,2], () => (__webpack_require__.e(3237).then(() => (() => (__webpack_require__(55618))))))),
	65387: () => (loadStrictVersion("default", "react-hook-form", false, [1,7,53,2], () => (__webpack_require__.e(2166).then(() => (() => (__webpack_require__(49785))))))),
	82861: () => (loadStrictVersion("default", "lucide-react", false, [2,0,474,0], () => (__webpack_require__.e(2711).then(() => (() => (__webpack_require__(45092))))))),
	11351: () => (loadStrictVersion("default", "tailwind-merge", false, [1,2,5,4], () => (__webpack_require__.e(8475).then(() => (() => (__webpack_require__(50856))))))),
	10455: () => (loadStrictVersion("default", "crypto-js", false, [1,4,2,0], () => (Promise.all([__webpack_require__.e(9015), __webpack_require__.e(2858)]).then(() => (() => (__webpack_require__(21396))))))),
	22438: () => (loadStrictVersion("default", "js-cookie", false, [1,3,0,5], () => (__webpack_require__.e(1368).then(() => (() => (__webpack_require__(18987))))))),
	31952: () => (loadStrictVersion("default", "fuse.js", false, [1,7,1,0], () => (__webpack_require__.e(8310).then(() => (() => (__webpack_require__(25929))))))),
	95982: () => (loadStrictVersion("default", "immer", false, [1,10,1,1], () => (__webpack_require__.e(9551).then(() => (() => (__webpack_require__(1932))))))),
	14067: () => (loadStrictVersion("default", "react-markdown", false, [1,9,0,1], () => (Promise.all([__webpack_require__.e(6810), __webpack_require__.e(3723)]).then(() => (() => (__webpack_require__(56104))))))),
	21084: () => (loadStrictVersion("default", "rehype-raw", false, [1,7,0,0], () => (Promise.all([__webpack_require__.e(6810), __webpack_require__.e(4248)]).then(() => (() => (__webpack_require__(81867))))))),
	30919: () => (loadStrictVersion("default", "rehype-sanitize", false, [1,6,0,0], () => (__webpack_require__.e(5998).then(() => (() => (__webpack_require__(53617))))))),
	12519: () => (loadStrictVersion("default", "@e-llm-studio/citation", false, [3,0,0,29], () => (Promise.all([__webpack_require__.e(6854), __webpack_require__.e(2874)]).then(() => (() => (__webpack_require__(84473))))))),
	86825: () => (loadStrictVersion("default", "uuid4", false, [1,2,0,3], () => (__webpack_require__.e(5879).then(() => (() => (__webpack_require__(78260))))))),
	72876: () => (loadStrictVersion("default", "@mui/material", false, [1,6,5,0], () => (Promise.all([__webpack_require__.e(304), __webpack_require__.e(5954)]).then(() => (() => (__webpack_require__(43573))))))),
	62936: () => (loadStrictVersion("default", "@e-llm-studio/streaming-response", false, [1,1,1,35], () => (__webpack_require__.e(384).then(() => (() => (__webpack_require__(28003))))))),
	28859: () => (loadStrictVersion("default", "@e-llm-studio/instant-learning", false, [3,0,0,49], () => (Promise.all([__webpack_require__.e(6239), __webpack_require__.e(2839)]).then(() => (() => (__webpack_require__(18620))))))),
	551: () => (loadStrictVersion("default", "lottie-react", false, [1,2,4,1], () => (Promise.all([__webpack_require__.e(2272), __webpack_require__.e(432)]).then(() => (() => (__webpack_require__(18051))))))),
	9288: () => (loadStrictVersion("default", "@radix-ui/react-slot", false, [1,1,0,2], () => (__webpack_require__.e(5743).then(() => (() => (__webpack_require__(33362))))))),
	64483: () => (loadStrictVersion("default", "react-syntax-highlighter", false, [1,15,6,1], () => (__webpack_require__.e(3490).then(() => (() => (__webpack_require__(11109))))))),
	84743: () => (loadStrictVersion("default", "@exuanbo/file-icons-js", false, [1,3,3,0], () => (__webpack_require__.e(7743).then(() => (() => (__webpack_require__(12981))))))),
	30431: () => (loadStrictVersion("default", "dayjs", false, [1,1,11,13], () => (__webpack_require__.e(6734).then(() => (() => (__webpack_require__(74353))))))),
	48654: () => (loadStrictVersion("default", "react-lottie-player", false, [1,2,1,0], () => (Promise.all([__webpack_require__.e(2272), __webpack_require__.e(819)]).then(() => (() => (__webpack_require__(33200))))))),
	38762: () => (loadStrictVersion("default", "@module-federation/utilities", false, [1,3,1,32], () => (__webpack_require__.e(4255).then(() => (() => (__webpack_require__(16636))))))),
	21079: () => (loadStrictVersion("default", "lodash", false, [1,4,17,21], () => (__webpack_require__.e(4924).then(() => (() => (__webpack_require__(2543))))))),
	19073: () => (loadStrictVersion("default", "wavesurfer.js", false, [1,7,8,9], () => (__webpack_require__.e(2330).then(() => (() => (__webpack_require__(49949))))))),
	41105: () => (loadStrictVersion("default", "react-frame-component", false, [1,5,2,7], () => (__webpack_require__.e(4141).then(() => (() => (__webpack_require__(96522))))))),
	49072: () => (loadStrictVersion("default", "react-resizable-panels", false, [1,2,1,7], () => (__webpack_require__.e(1408).then(() => (() => (__webpack_require__(9027))))))),
	40967: () => (loadStrictVersion("default", "is-online", false, [1,11,0,0], () => (__webpack_require__.e(3205).then(() => (() => (__webpack_require__(65586))))))),
	80079: () => (loadStrictVersion("default", "framer-motion", false, [1,11,18,2], () => (__webpack_require__.e(3534).then(() => (() => (__webpack_require__(11153))))))),
	98880: () => (loadStrictVersion("default", "@monaco-editor/react", false, [1,4,7,0], () => (__webpack_require__.e(1188).then(() => (() => (__webpack_require__(58807))))))),
	75271: () => (loadStrictVersion("default", "highlight.js", false, [1,11,11,1], () => (__webpack_require__.e(7497).then(() => (() => (__webpack_require__(19878))))))),
	19057: () => (loadStrictSingletonVersion("default", "reactflow", true, [1,11,11,4], () => (() => (__webpack_require__(41048))))),
	92467: () => (loadStrictVersion("default", "@react-oauth/google", false, [2,0,12,1], () => (__webpack_require__.e(9925).then(() => (() => (__webpack_require__(72306)))))))
};
var initialConsumes = [45850,2282];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"4706": [
		36114,
		12843
	],
	"5805": [
		45805
	],
	"7882": [
		18706,
		5335,
		65387,
		82861,
		11351,
		10455,
		22438,
		31952,
		95982,
		14067,
		21084,
		30919,
		12519,
		86825,
		72876,
		62936,
		28859,
		551,
		9288,
		64483,
		84743,
		30431,
		48654,
		38762,
		21079,
		19073,
		41105,
		49072,
		40967,
		80079,
		98880,
		75271,
		19057,
		92467
	],
	"8792": [
		45850,
		2282
	],
	"9112": [
		19234,
		82564,
		22026,
		27321
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}